<template>
    <!--    <transition name="show">-->
    <div v-show="open" class="menu">
        <div class="menu-container">
            <span class="close ico ico-close" @click="$emit('toggleMenu')"></span>
            <div class="menu--logo">
                <a href="/" :title="dictionary.siteHeader.logoTitle" role="link" width="115">
                    <img src="public/nuxt-assets/design2025/logo-green.svg" />
                </a>
            </div>
            <ul v-if="dictionary.siteHeader.counselling" class="menu-pinned">
                <li v-if="dictionary.siteHeader.counselling" class="menu__pinned">
                    <a
                        :href="dictionary.url.counselling"
                        class="menu__pinned-category menu__pinned-category--white"
                        :title="dictionary.siteHeader.counselling"
                        tabindex="-1"
                    >
                        <!--                            <i class="ico ico&#45;&#45;counselling" :title="dictionary.siteHeader.counselling"></i>-->
                        <span v-html="dictionary.siteHeader.counselling"></span>
                    </a>
                </li>
                <!--                    <li v-if="dictionary.siteHeader.pharmacies" class="menu__pinned">-->
                <!--                        <a :href="dictionary.url.pharmacies"-->
                <!--                            class="menu__pinned-category menu__pinned-category&#45;&#45;white"-->
                <!--                            :title="dictionary.siteHeader.pharmacies"-->
                <!--                            tabindex="-1"-->
                <!--                        >-->
                <!--                            <i class="ico ico&#45;&#45;pharmacy2" :title="dictionary.siteHeader.pharmacies"></i>-->
                <!--                            <span v-html="dictionary.siteHeader.pharmacies"></span>-->
                <!--                        </a>-->
                <!--                    </li>-->
<!--                <li v-if="dictionary.siteHeader.articles" class="menu__pinned">-->
<!--                    <a-->
<!--                        :href="dictionary.siteHeader.articles.url"-->
<!--                        class="menu__pinned-category menu__pinned-category&#45;&#45;white"-->
<!--                        :title="dictionary.siteHeader.articles.title"-->
<!--                        tabindex="-1"-->
<!--                    >-->
<!--                        <span v-html="dictionary.siteHeader.articles.title"></span>-->
<!--                    </a>-->
<!--                </li>-->
            </ul>
            <ul class="menu-pinned">
                <li
                    v-for="(pinnedCategory, index) in pinnedCategories"
                    :key="index"
                    class="menu__pinned"
                    :class="`type-${pinnedCategory.id}`"
                >
                    <a :href="pinnedCategory.url" class="menu__pinned-category" :title="pinnedCategory.title /*strip tags*/" tabindex="-1">
                        <span v-html="pinnedCategory.title"></span>
                    </a>
                </li>
            </ul>
            <ul>
                <li class="menu__label__cat fwb">{{ dictionary.siteHeader.category }}</li>
                <li
                    v-for="(menuItem, idx) in items"
                    :key="idx"
                    class="menu-item"
                    :class="{
                        'menu-item--highlight menu-item--xmas': xmasCategoryId === menuItem.id,
                        'menu-item--highlight menu-item--sale': menuHighlightCategory === menuItem.id,
                    }"
                >
                    <a
                        class="menu-item__link"
                        :class="{ 'menu-item--link--highlighted': menuItem.isHighlighted }"
                        :href="menuItem.url"
                        @click="menuMouseClick"
                    >
                        {{ menuItem.name }}
                        <i v-if="menuItem.items.length > 0" class="ico ico-arrow-menu float-right"></i>
                    </a>
                    <a class="goBack" :href="menuItem.url">{{ dictionary.siteHeader.seeAllCategory }} {{ menuItem.name }} </a>
                    <!--                        <transition name="opacity">-->
                    <div v-if="menuItem.items.length > 0" class="menu__submenu">
                        <ul>
                            <li v-for="(menuItem1, idx) in menuItem.items" :key="idx" class="menu__submenu__item">
                                <a class="menu__submenu__item__link" :href="menuItem1.url" @click.prevent="submenuMouseClick">
                                    {{ menuItem1.name }}
                                    <i v-if="menuItem1.items.length > 0" class="ico ico-arrow-menu float-right"></i>
                                </a>
                                <a class="goBack" :href="menuItem1.url">{{ dictionary.siteHeader.seeAllCategory }} {{ menuItem1.name }} </a>

                                <div
                                    v-if="menuItem1.items.length > 0"
                                    class="menu__submenu menu__submenu--1"
                                    :style="{ height: menuItem1.items.length * 50 + 560 + 'px' }"
                                >
                                    <ul>
                                        <li
                                            v-for="(menuItem2, menuItem2Index) in menuItem1.items"
                                            :key="menuItem2Index"
                                            class="menu__subsubmenu__item"
                                        >
                                            <a class="menu__submenu__item__link" :href="menuItem2.url">{{ menuItem2.name }} </a>
                                        </li>
                                        <BrandsPoster
                                            :dictionary="dictionary"
                                            @hideMenu="hideMenu"
                                            :menu-banners="menuBanners.filter((item) => item.objectId === menuItem.id)"
                                            :is-pwa="isPwa"
                                            @redirectToUrl="redirectToUrl"
                                        />
                                        <ProductPoster
                                            v-if="menuItemProducts[menuItem.objectId]"
                                            :dictionary="dictionary"
                                            class="mobile-product"
                                            :product="menuItemProducts[menuItem.objectId].product"
                                            :title="menuItemProducts[menuItem.objectId].title"
                                            :is-pwa="isPwa"
                                            :basket-amount="getProductCountForPosterProduct(menuItem.objectId)"
                                            @hideMenu="hideMenu"
                                            @addProductToBasket="addProductToBasket"
                                            @redirectToUrl="redirectToUrl"
                                        >
                                            <template v-slot:product="{ product }">
                                                <slot name="product" v-bind="{ product }"></slot>
                                            </template>
                                        </ProductPoster>
                                    </ul>
                                </div>
                            </li>
                            <BrandsPoster
                                :dictionary="dictionary"
                                @hideMenu="hideMenu"
                                :menu-banners="menuBanners.filter((item) => item.objectId === menuItem.id)"
                                :is-pwa="isPwa"
                                @redirectToUrl="redirectToUrl"
                            />
                            <ProductPoster
                                v-if="menuItemProducts[menuItem.objectId]"
                                :dictionary="dictionary"
                                class="mobile-product"
                                :product="menuItemProducts[menuItem.objectId].product"
                                :title="menuItemProducts[menuItem.objectId].title"
                                :is-pwa="isPwa"
                                :basket-amount="getProductCountForPosterProduct(menuItem.objectId)"
                                @hideMenu="hideMenu"
                                @addProductToBasket="addProductToBasket"
                                @redirectToUrl="redirectToUrl"
                            >
                                <template v-slot:product="{ product }">
                                    <slot name="product" v-bind="{ product }"></slot>
                                </template>
                            </ProductPoster>
                        </ul>
                    </div>
                    <!--                        </transition>-->
                </li>
            </ul>
        </div>
    </div>
    <!--    </transition>-->
</template>

<script>
import BrandsPoster from '../elements/BrandsPoster'
import ProductPoster from '../elements/ProductPoster'

export default {
    components: {
        BrandsPoster,
        ProductPoster,
    },
    props: {
        productAmounts: {
            type: Object,
            required: false,
            default: () => {},
        },
        isPwa: {
            type: Boolean,
            required: true,
        },
        items: {
            default: false,
        },
        pinnedCategories: {
            default: false,
        },
        saleBanners: {
            type: Object,
            default: () => {},
        },
        menuBanners: {
            default: false,
        },
        menuBrandBanners: {
            type: Array,
        },
        open: {
            default: false,
        },
        menuItemProducts: {
            default: false,
        },
        langDefault: {
            type: String,
            default: '',
        },
        xmasCategoryId: {
            type: Number,
            required: false,
        },
        menuHighlightCategory: {
            type: Number,
            required: false,
        },
        dictionary: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            openMenu: this.open,
        }
    },

    methods: {
        addProductToBasket(data) {
            this.$emit('addProductToBasket', data)
        },

        redirectToUrl(data) {
            this.$emit('redirectToUrl', data)
        },

        hideMenu() {
            this.$emit('toggleMenu')
        },

        menuMouseClick(event) {
            var submenu = event.target
            if (submenu.parentElement.getElementsByClassName('menu__submenu').length === 0) {
                submenu = event.target.parentElement
            }

            if (!this.isDesktop && submenu.parentElement.getElementsByClassName('menu__submenu').length > 0) {
                event.preventDefault()

                if (document.querySelectorAll('.is-open').length > 0) {
                    if (submenu) {
                        document.querySelectorAll('.is-open').forEach(function (item) {
                            item.classList.remove('is-open')
                        })
                        document.getElementsByClassName('menu-container')[0].classList.remove('menu-container--open_submenu')
                    }
                } else {
                    const submenu = event.target.parentElement

                    if (submenu) {
                        submenu.parentElement.querySelectorAll('.is-open').forEach(function (item) {
                            item.classList.remove('is-open')
                        })

                        submenu.classList.add('is-open')
                        submenu.parentElement.classList.add('is-open')

                        document.getElementsByClassName('menu-container')[0].classList.add('menu-container--open_submenu')
                    }
                }
            } else {
                window.location = event.target.href
            }
        },

        submenuMouseClick(event) {
            var submenu = event.target.parentElement

            if (event.target.classList.contains('ico-arrow-menu')) {
                submenu = event.target.parentElement.parentElement
            }

            if (submenu.parentElement.getElementsByClassName('menu__submenu').length === 0) {
                submenu = event.target.parentElement.parentElement
            }

            if (!this.isDesktop && submenu.getElementsByClassName('menu__submenu').length > 0) {
                event.preventDefault()
                document.getElementsByClassName('menu-container')[0].scrollTop = 0
                if (submenu.classList.contains('is-open')) {
                    submenu.classList.remove('is-open')
                    submenu.parentElement.classList.remove('is-open')

                    document.getElementsByClassName('menu-container')[0].classList.remove('menu-container--open_submenu2')
                } else {
                    submenu.parentElement.querySelectorAll('.is-open').forEach(function (item) {
                        item.classList.remove('is-open')
                    })

                    submenu.classList.add('is-open')
                    submenu.parentElement.classList.add('is-open')

                    document.getElementsByClassName('menu-container')[0].classList.add('menu-container--open_submenu2')
                }
            } else {
                window.location = event.target.href
            }
        },

        getProductCountForPosterProduct(objectId) {
            const menuItemProduct = this.menuItemProducts[objectId]
            if (!menuItemProduct) {
                return 0
            }
            const product = menuItemProduct.product
            if (!product) {
                return 0
            }
            return this.productAmounts[product.id] || 0
        },
    },
}
</script>

<style lang="scss" scoped>
.menu-item.is-open > .menu__submenu > .mobile-brands,
.menu__submenu__item.is-open > .mobile-brands,
.menu-item.is-open > .menu__submenu > .mobile-product,
.menu__submenu__item.is-open > .mobile-product {
    display: block;
}

.menu {
    position: fixed;
    flex-direction: column;
    width: 100%;
    top: 0;
    bottom: 0;
    z-index: 500;
    left: 0;
    overflow: auto;
    background: #e9f8eb;
    overflow-y: auto;

    &--logo {
        text-align: center;
        svg {
            width: 120px;
        }
    }

    a {
        text-decoration: none;
    }

    @media (min-width: 992px) {
        display: none;
    }

    .close {
        right: 20px;
        position: absolute;
        height: 15px;
        width: 15px;
        top: 20px;
        cursor: pointer;
        padding: 20px;
        background-size: 44%;
    }

    &__logo {
        margin: 0 25px;
    }

    .menu-pinned {
        padding: 0 10px 0 5px;
        margin: 0;
        background-color: #e9f8eb;
    }

    &__pinned {
        display: inline-block;
        margin: 5px 5px;
    }

    .menu__pinned-category {
        padding: 0 13px;
        background: #c6e9c9;
        border-radius: 100px;
        color: #333333;
        font-size: 14px;
        font-weight: 600;
        border: 0;
        height: 38px;
        display: flex;
        align-items: center;

        &--white {
            background: #fff;
            border: 1px solid #a1cdc0;
            gap: 10px;

            span {
                font-size: 14px;
                font-weight: 400;
            }

            .ico.ico--counselling {
                width: 24px;
                height: 20px;
            }
        }
    }

    .goBack {
        width: 100%;
        color: #146154;
        border-top: 0.5px solid #f0f0f0;
        display: none;
        padding: 15px 0 10px 15px;
        text-align: left;
        font-weight: 500;
    }

    &-container {
        position: relative;
        background: #e9f8eb;
        width: 100%;
        padding-top: 20px;
        min-height: 80%;

        @media (min-width: 992px) {
            width: 210px;
        }

        &--open_submenu {
            overflow-y: scroll;
            height: 100%;

            .menu-item {
                display: none;

                &.is-open {
                    display: block;
                }
            }
        }
    }

    &__label__cat {
        text-align: left;
        padding: 25px 25px 15px;
        border-bottom: 0.5px solid #f0f0f0ff;
        text-transform: uppercase;

        @media (max-width: 992px) {
            display: none;
        }
    }

    &__submenu {
        position: absolute;
        left: -100%;
        background: #fff;
        min-width: 100vw;
        z-index: 999;
        transition: all 0.5s;
        width: 100%;
        height: 0;
        display: none;

        @media (min-width: 992px) {
            left: 100%;
            top: 0;
            min-width: 900px;
        }

        &--1 {
            min-height: 100vh;
            min-width: auto;
            display: none;
        }

        > ul {
            width: 100%;

            @media (min-width: 992px) {
                width: 33%;
            }
        }

        &__item {
            &__link {
                border: none;
                color: #333333;
                display: block;
            }

            &.is-open {
                .menu__submenu {
                    left: 0;
                }
            }
        }
    }

    ul {
        padding-left: 0;
        background-color: #fff;

        li {
            list-style-type: none;

            a {
                color: #333333;
                border-top: 0.5px solid #e9f8eb;
                padding: 15px;
                line-height: 18px;
            }
        }

        .menu-item {
            position: relative;
            border-bottom: 0.5px solid #f0f0f0;

            &.is-open {
                @media (max-width: 992px) {
                    > .goBack {
                        display: block;
                    }

                    .menu__submenu {
                        a {
                            color: #333333;
                            border-top: 0.5px solid #f0f0f0;
                            padding: 15px;
                        }

                        ul.is-open {
                            li {
                                display: none;

                                &.is-open {
                                    display: block;

                                    .menu__submenu--1 {
                                        li {
                                            display: block;
                                        }
                                    }

                                    > .goBack {
                                        display: block;
                                        color: #146154;
                                    }
                                }
                            }
                        }
                    }
                }

                > .menu__submenu {
                    left: 0;
                }
            }

            &__link {
                display: block;
                padding: 15px;
                color: #333;
                text-align: left;
                position: relative;
                line-height: 16px;
                transition: all 0.5s;

                @media (min-width: 960px) {
                    padding: 13px 5px 13px 25px;

                    .ico-arrow-menu {
                        display: none;
                    }
                }
            }

            &__submenu {
                display: none;
            }

            &:hover {
                .ico-arrow-menu {
                    display: block;
                }
            }

            &--highlight:not(.is-open) {
                .menu-item__link {
                    color: #146154;
                    padding-left: 40px;

                    &:before {
                        display: inline-block;
                        background-size: cover;
                        width: 20px;
                        height: 20px;
                        content: '';
                        position: absolute;
                        left: 15px;
                        top: 12px;
                    }
                }
            }
            &--xmas:not(.is-open) .menu-item__link:before {
                background: transparent url('../../icons/xmas.svg') no-repeat scroll 50% 50%;
            }
            &--sale:not(.is-open) .menu-item__link:before {
                background: transparent url('../../icons/sale.svg') no-repeat scroll 50% 50%;
            }
        }

        &.menu__submenu {
            left: 33%;
            width: auto;

            @media (max-width: 992px) {
                left: -100%;
                width: 95%;
                top: 90px;
            }

            a {
                color: #6b6b6b;
            }
        }
    }

    > ul {
        margin: 0;

        @media (max-width: 992px) {
            width: 100%;
        }
    }
}

.is-open {
    .menu__submenu {
        height: auto;
        padding-bottom: 120px;
        display: block;

        .menu__submenu {
            padding-bottom: 40px;
            display: none;
        }

        .is-open {
            .menu__submenu {
                padding-bottom: 40px;
                display: block;
            }
        }
    }
}

.menu-container.menu-container--open_submenu.menu-container--open_submenu2 {
    .menu-item.is-open {
        .menu-item__link {
            display: none;
        }

        .goBack {
            display: none;
        }
    }
}

.show {
    &-enter,
    &-leave-to {
        opacity: 0;
        transform: translateX(-60px);
    }

    &-enter-active,
    &-leave-active {
        transition: all 500ms;
    }
}

.fade {
    &-enter {
        opacity: 0;
        transform: translateX(-60px);
    }

    &-enter-active {
        transition: all 500ms ease-in-out;
        transition-delay: calc(50ms * var(--index));
    }
}

.opacity {
    &-enter {
        opacity: 1;
    }

    &-enter-active {
        opacity: 0;
    }
}

@media (max-width: 992px) {
    .ico {
        transform: rotate(0deg);
    }

    .is-open {
        > a {
            color: #333333;
            background: transparent;
            font-weight: 500;

            .ico {
                float: left;
                transform: rotate(180deg);
                margin-left: -4px;
                margin-right: 5px;
            }
        }
    }
}
</style>
